import type { CanvasTarget } from '../../types';
import { appPreviewTarget } from './tool-output';

/** The slice of a message part this needs: a completed tool call with its result. */
export type PreviewPart = { type?: string; toolName?: string; result?: unknown };

/**
 * The App preview to reopen from a saved message: the LAST completed preview/open call whose retained output
 * names a preview of THIS conversation (the same validation the live arrival uses). The latest snapshot is the
 * finished App; earlier snapshots of the same build are the in-progress ones. Null when there is none, so a message
 * without an App shows no control.
 */
export function latestAppPreview(
  parts: readonly PreviewPart[],
  threadId: string | undefined,
): CanvasTarget | null {
  if (!threadId) return null;
  for (let index = parts.length - 1; index >= 0; index--) {
    const part = parts[index];
    if (part?.type !== 'tool-call') continue;
    const target = appPreviewTarget(part.toolName ?? '', part.result, threadId);
    if (target) return target;
  }
  return null;
}
